var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorasFechamento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    fill: "#212121"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2862_3170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9506 8.32532C18.6103 8.32532 21.5769 11.2919 21.5769 14.9517C21.5769 18.6114 18.6103 21.578 14.9506 21.578C11.2908 21.578 8.32422 18.6114 8.32422 14.9517C8.32422 11.2919 11.2908 8.32532 14.9506 8.32532ZM14.9506 10.9759C14.7748 10.9759 14.6063 11.0457 14.482 11.1699C14.3577 11.2942 14.2879 11.4627 14.2879 11.6385V14.9517C14.288 15.1274 14.3578 15.2959 14.4821 15.4201L16.47 17.408C16.595 17.5288 16.7623 17.5955 16.9361 17.594C17.1098 17.5925 17.276 17.5228 17.3989 17.4C17.5217 17.2771 17.5914 17.1109 17.5929 16.9372C17.5944 16.7634 17.5277 16.5961 17.4069 16.4711L15.6132 14.6773V11.6385C15.6132 11.4627 15.5434 11.2942 15.4191 11.1699C15.2948 11.0457 15.1263 10.9759 14.9506 10.9759Z",
    fill: "#6796CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2862_3170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9032,
    height: 15.9032,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorasFechamento);
export default __webpack_public_path__ + "static/media/horasFechamento.d214f3cc077bac88e8fd2db8658a20eb.svg";
export { ForwardRef as ReactComponent };